export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  content: {
    marginTop: '15px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline',
    gap: '15px',
  },

  informationAndAddressWrapper: {
    position: 'relative',
    display: 'flex',
    minWidth: 0,
    wordWrap: 'break-word',
    backgroundColor: '#fff',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    backgroundClip: 'border-box',
    border: '1px solid rgba(72, 94, 144, 0.16)',
    padding: 2,
    marginBottom: 4,
    borderRadius: '8px',
    boxShadow: '1px 3px 5px rgb(0 0 0 / 10%)',
  },

  activityWrapper: {
    position: 'relative',
    display: 'flex',
    minWidth: 0,
    wordWrap: 'break-word',
    backgroundColor: '#fff',
    flexDirection: 'column',
    backgroundClip: 'border-box',
    border: '1px solid rgba(72, 94, 144, 0.16)',
    padding: 2,
    marginBottom: 4,
    borderRadius: '8px',
    boxShadow: '1px 3px 5px rgb(0 0 0 / 10%)',
  },
  informationActivitiesContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
};
